module.exports = __webpack_public_path__ + "static/media/java.3a6a7cd0.pdf";